import _ from 'lodash';

module.exports = {
    indexFromInterval: function (intervalMs, arrLength) {
        let totalTimePassed = new Date().getTime();
        let loops = (totalTimePassed / intervalMs);
        return Math.floor(loops % arrLength);
    },

    elementIndexCurrentSeekTime: function(intervalMs) {
        let totalTimePassed = new Date().getTime();
        let loops = (totalTimePassed / intervalMs);
        let currentLoop = Math.floor(loops);
        let currentTimeInInterval = totalTimePassed - (currentLoop * intervalMs);

        return currentTimeInInterval;
    },

    currentSeekTimeArray: function(intervals) {
        let intervalsSum = [];
        intervals.reduce((a, b, i) => { return intervalsSum[i] = a + b}, 0);

        let totalTimePassed = new Date().getTime();
        let totalCycleTime = _.sum(intervals);
        let loops = totalTimePassed / totalCycleTime;
        let percentageIntoLoop = loops % 1;
        let timeIntoLoop = percentageIntoLoop * totalCycleTime;

        let index = _.findIndex(intervalsSum, (sum) => {
            return timeIntoLoop / sum < 1;
        });
        
        return timeIntoLoop % intervals[index];
    },

    indexFromIntervalArray: function(intervals) {
        let intervalsSum = [];
        intervals.reduce((a, b, i) => { return intervalsSum[i] = a + b}, 0);

        let totalTimePassed = new Date().getTime();
        let totalCycleTime = _.sum(intervals);
        let loops = totalTimePassed / totalCycleTime;
        let percentageIntoLoop = loops % 1;
        let timeIntoLoop = percentageIntoLoop * totalCycleTime;

        let index = _.findIndex(intervalsSum, (sum) => {
            return timeIntoLoop / sum < 1;
        });
        return index;
    },

    timeIntervalRemainderArrayMS: function(intervals, pushToTemp = false) {
        let intervalsSum = [];
        let totalTimePassed = new Date().getTime();
        intervals.reduce((a, b, i) => { return intervalsSum[i] = a + b}, 0);

        let totalCycleTime = _.sum(intervals);
        let loops = totalTimePassed / totalCycleTime;
        let percentageIntoLoop = loops % 1;
        let timeIntoLoop = percentageIntoLoop * totalCycleTime;

        let index = _.findIndex(intervalsSum, (sum) => {
            return timeIntoLoop < sum;
        });

        if (pushToTemp) {
            window.tmpLogArray.push(new Date() + " total cycle time: " + totalCycleTime);
            window.tmpLogArray.push(new Date() + " loops: " + loops);
            window.tmpLogArray.push(new Date() + " percentageIntoLoop: " + percentageIntoLoop);
            window.tmpLogArray.push(new Date() + " index calculated: " + timeIntoLoop);
        }

        return intervalsSum[index] - timeIntoLoop;
    },

    timeIntervalRemainderPercent: function (intervalMs) {
        let totalTimePassed = new Date().getTime();
        return 1 - ((totalTimePassed / intervalMs) % 1)
    },

    timeIntervalRemainderMS: function (intervalMs){
        return this.timeIntervalRemainderPercent(intervalMs) * intervalMs;
    },

    diff: function(d1, d2, span){
        let diff = Math.abs(d2 - d1)
        switch(span){
            case "milliseconds":
            return diff
            case "seconds":
            return diff/1000
            case "minutes":
            return diff/1000/60
            case "hours":
            return diff/1000/60/60
            case "days":
            return diff/1000/60/60/24
            default:
            return diff;
        }
    }

}



// WEBPACK FOOTER //
// ./src/utils/timeHelpers.js